import React from 'react';
import { create } from 'jss';
import rtl from 'jss-rtl';
import {
  StylesProvider,
  jssPreset,
  makeStyles,
} from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import MaterialThemeProvider from './MaterialThemeProvider';

const jss = create({ plugins: [...jssPreset().plugins, rtl()] });
const useStyles = makeStyles({
  '@global': {
    body: {
      background: '#F1F3F7',
      overFlowY: 'hidden',
    },
  },
});

export default function MaterialWrapper(props) {
  useStyles();
  return (
    <StylesProvider jss={jss}>
      <MaterialThemeProvider>
        <CssBaseline />
        {props.children}
      </MaterialThemeProvider>
    </StylesProvider>
  );
}
